module.exports = __webpack_public_path__ + "img/office-1984-renminribao.c82f4a0c.jpg";